export { RegionalCenterRegionsInfo } from './regional-center-regions-info';
